import { render, staticRenderFns } from "./HospitalDoctorInfoTable.vue?vue&type=template&id=0a3db052&scoped=true&"
import script from "./HospitalDoctorInfoTable.vue?vue&type=script&lang=js&"
export * from "./HospitalDoctorInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./HospitalDoctorInfoTable.vue?vue&type=style&index=0&id=0a3db052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3db052",
  null
  
)

export default component.exports